import { Component, Input, ViewEncapsulation } from "@angular/core";
import { SafePipe } from "@app/shared/pipes/safe.pipe";

@Component({
    selector: "print-process-flow",
    templateUrl: "./print-process-flow.component.html",
    styleUrls: ["./print-process-flow.component.scss"],
    encapsulation: ViewEncapsulation.ShadowDom,
    imports: [SafePipe],
})
export class PrintProcessFlowComponent {
    @Input() public printGraph: string;
}
